import { useMemo } from 'react';
import { CampaignType_Enum as CampaignType } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { NoAccessEmptyState } from '@frontend/assets';
import { useTranslation } from '@frontend/i18n';
import { EmptyState } from './empty-state';

type Props = {
  campaignType?: CampaignType;
};

export const EmptyStateNoAccess = ({ campaignType }: Props) => {
  const { t } = useTranslation('bulk-messaging');

  const message = useMemo(() => {
    if (campaignType === undefined) return t('You do not have permission to view or edit marketing campaigns.');
    if (campaignType === CampaignType.SMS) return t('You do not have permission to view or edit text campaigns.');
    return t('You do not have permission to view or edit email campaigns.');
  }, [campaignType, t]);

  return (
    <EmptyState message={message}>
      <NoAccessEmptyState css={{ width: 375, height: 375 }} />
    </EmptyState>
  );
};
